// extracted by mini-css-extract-plugin
export default {"ViewMode":"ViewMode_ViewMode__cPV4q"};